import { buildLink } from '@amazeelabs/react-framework-bridge/gatsby';
import * as yup from 'yup';

import { useQueryParameters } from './use-query-parameters';

/**
 * Schema for pagination parameters.
 */
export const paginationSchema = yup.object({
  page: yup.number().min(1).default(1),
});

/**
 * Create query-dependent properties for the pagination component.
 */
export const usePagination = () => {
  const { page, ...args } =
    useQueryParameters<{ page?: number }>(paginationSchema);
  return {
    Link: buildLink<{ page: string }>({ query: args }),
    currentPage: page,
  };
};
